export default __webpack_public_path__ + "37edec3e1ba30e26a5b60c6c7795d29b.png";